import React from 'react';
import SectionWithParagraph from 'components/organisms/section/sectionWithParagraph';
import SectionWithList from 'components/organisms/section/sectionWithList';
import PERSONAL_INFORMATION from './constants/ConstPersonalInformation';

export default function About() {
  return (
    <div className='flex flex-col gap-4'>
      <SectionWithParagraph title="About" description={PERSONAL_INFORMATION.about} />
      <SectionWithList title="Basic Information" items={PERSONAL_INFORMATION.basicInformation} />
    </div>
  );
}
